import { type PuzzleLevelSource } from './cat-puzzle.js';

/**
 * The built-in level pack, easiest first (spec §6.14.4: "a small level-pack JSON"). Ids are stored
 * with scores, so never rename one; add new levels at the end. `par` is the optimum, which the
 * tests check with a solver.
 */
export const CAT_PUZZLE_LEVELS: readonly PuzzleLevelSource[] = [
  {
    id: 'first-steps',
    name: { en: 'First steps', sv: 'Första stegen' },
    par: 3,
    rows: [
      '#######', //
      '#@ C .#',
      '#######',
    ],
  },
  {
    id: 'sunbeam',
    name: { en: 'Sunbeam', sv: 'Solstrimman' },
    par: 5,
    rows: [
      '-######', //
      '-#.   #',
      '##C## #',
      '#  $ .#',
      '# @   #',
      '#######',
    ],
  },
  {
    id: 'round-the-corner',
    name: { en: 'Round the corner', sv: 'Runt hörnet' },
    par: 6,
    rows: [
      '######', //
      '#    #',
      '#@C  #',
      '#  # #',
      '### .#',
      '######',
    ],
  },
  {
    id: 'under-the-desk',
    name: { en: 'Under the desk', sv: 'Under skrivbordet' },
    par: 11,
    rows: [
      '-######', //
      '-#@   #',
      '##C$# #',
      '#   . #',
      '#  . ##',
      '######-',
    ],
  },
  {
    id: 'two-boxes',
    name: { en: 'Two boxes', sv: 'Två lådor' },
    par: 17,
    rows: [
      '#######', //
      '#.  ..#',
      '# $ $ #',
      '## C ##',
      '-# @ #-',
      '-#####-',
    ],
  },
  {
    id: 'coffee-break',
    name: { en: 'Coffee break', sv: 'Fikapaus' },
    par: 25,
    rows: [
      '-#######', //
      '-#  .  #',
      '##$#C# #',
      '#  .$  #',
      '#.  #@ #',
      '########',
    ],
  },
  {
    id: 'printer-jam',
    name: { en: 'Printer jam', sv: 'Pappersstopp' },
    par: 25,
    rows: [
      '########', //
      '#@     #',
      '# C$   #',
      '#   #. #',
      '###   .#',
      '--######',
    ],
  },
  {
    id: 'kintsugi',
    name: { en: 'Kintsugi', sv: 'Kintsugi' },
    par: 27,
    rows: [
      '#########', //
      '#   #   #',
      '# $ C $ #',
      '#  ...  #',
      '### @ ###',
      '--#####--',
    ],
  },
  {
    id: 'meeting-room',
    name: { en: 'Meeting room', sv: 'Mötesrummet' },
    par: 38,
    rows: [
      '#######', //
      '#  .  #',
      '# $C$ #',
      '#. # .#',
      '#  @  #',
      '#######',
    ],
  },
];

export function catPuzzleLevel(id: string): PuzzleLevelSource | undefined {
  return CAT_PUZZLE_LEVELS.find((level) => level.id === id);
}
